import { SuccessLayout } from "@/layouts/SuccessLayout";
import { ThankYouPageHeader } from "./ThankYouPageHeader";
import { ThankYouPageContent } from "./ThankYouPageContent";
import { ThankYouPageVideo } from "./ThankYouPageVideo";
import { formatCurrency } from "@/utils/formatters";
import { useDonationFormStore } from "@/stores";
import type { ThankYouPageProps } from "./ThankYouPageProps";

export function ThankYouPage(props: ThankYouPageProps) {
  const {
    config,
    donationReference,
    enableFrontline,
    enableGiftAid,
    submissionId,
    missingComponentsToken,
    amount,
    amountGift,
  } = props;

  const { personalDetails } = useDonationFormStore();

  const translationsParams = {
    amount: formatCurrency(amount),
    donation_reference: donationReference,
    name: personalDetails.firstName,
    amount_gift: formatCurrency(amount + amountGift),
  };

  return (
    <SuccessLayout
      header={
        <ThankYouPageHeader
          config={config}
          translationsParams={translationsParams}
        />
      }
      content={
        <ThankYouPageContent
          config={config}
          translationsParams={translationsParams}
          enableFrontline={enableFrontline}
          enableGiftAid={enableGiftAid}
          submissionId={submissionId}
          missingComponentsToken={missingComponentsToken}
        />
      }
      video={<ThankYouPageVideo config={config} />}
    />
  );
}
